import { CalculateTaxParams } from './useCalculateTax.interface';

/**
 * Query key factory for the self-calculate estimate. Extracted so the hook and
 * any invalidations can't drift apart — the params are part of the key because
 * every field changes the resulting estimate.
 */
const calculateTaxKeys = {
    all: ['tax', 'calculateTax'] as const,
    byParams: (params?: CalculateTaxParams) => ['tax', 'calculateTax', params] as const,
};

export default calculateTaxKeys;
